import ParticipantsAndRecommendationsModule from "./participantsAndRecommendations";
import SellerModule from "./seller";
import PaperWorkModule from "./paperwork";
import MembershipModule from "./membership";
import UserTypeModule from "./userType";

export default {
    participantsAndRecommendations: ParticipantsAndRecommendationsModule,
    seller: SellerModule,
    paperwork: PaperWorkModule,
    membership: MembershipModule,
    userType: UserTypeModule
}
